import authApis from "./authApis.ts";
import backendApis from "./backendApis.ts";
import extractionApis from "./extractionApis.ts";

export default {
  authApis,
  backendApis,
  extractionApis,
}
